// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__MBGR1","message":"style__message__uyvR9"};